import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaUser, FaBuilding } from 'react-icons/fa';
import UserInfoCard from './UserInfoCard';

const DetailModal = ({ show, data, onHide, isFavorito, onToggleFavorito, podeVerSenhaAprovacao }) => {
  if (!data) return null;

  const titulo = data.is_user ? 'Detalhes do Usuário' : 'Detalhes do Cliente';

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered dialogClassName="consulta-acesso-modal">
      <style>{`
        .consulta-acesso-modal .modal-content {
          border-radius: 16px;
          border: none;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          overflow: hidden;
        }
      `}</style>
      <Modal.Header
        closeButton
        style={{
          background: 'linear-gradient(135deg, #0747a6 0%, #0a5dc2 100%)',
          color: '#fff',
          borderBottom: 'none',
          padding: '18px 24px',
        }}
      >
        <Modal.Title style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          {data.is_user ? <FaUser /> : <FaBuilding />}
          {titulo}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="detail-modal-body" style={{ padding: '8px 20px 20px' }}>
        <UserInfoCard
          data={data}
          isFavorito={isFavorito}
          onToggleFavorito={onToggleFavorito}
          podeVerSenhaAprovacao={podeVerSenhaAprovacao}
        />
      </Modal.Body>
    </Modal>
  );
};

export default DetailModal;
